import React from 'react';

export const MapStoreContext = React.createContext(null);
